import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'msc-manage-instance-stats',
    templateUrl: './stats.component.html'
})
export class ManageInstanceStatsComponent implements OnInit {

    constructor() {}

    ngOnInit(): void {}
}
